<template>
  <div>
    <div v-if="$router.currentRoute.name === 'routes-events'">
      <h1 class="text-xs-center">Events</h1>
      <div class="layout justify-space-between">
        <div>
          <v-btn flat :disabled="apiInProgress" :to="{ name: 'routes' }">
            <v-icon left>fal fa-route</v-icon> Routes
          </v-btn>
        </div>
        <div class="text-xs-right">
          <v-btn
            class="primary"
            :disabled="apiInProgress || !hasUserType('admin') || isOnlyInvestor"
            @click="loadEvent('0')"
          >
            <v-icon left>fal fa-plus</v-icon> Create Event
          </v-btn>
        </div>
      </div>
      <v-layout row wrap>
        <v-flex md5 sm3 pa-2>
          <form @submit.prevent="() => searchEvents(1)">
            <v-text-field
              solo
              v-model="searchKeywords"
              append-icon="fal fa-search"
              :rules="[v => !v || v.length >= 2 || 'Min 2 characters']"
              :disabled="apiInProgress"
              type="search"
              placeholder="Search event name"
              @click:append="() => searchEvents(1)"
            />
          </form>
        </v-flex>
        <v-flex md4 sm4 pa-2>
          <v-layout>
            <v-flex xs6>
              <st-date-field
                id="route-events-date-from"
                v-model="dateFrom"
                label="(From) Event Date"
                to-date-id="route-events-date-to"
              />
            </v-flex>
            <v-flex xs6 pl-2>
              <st-date-field
                id="route-events-date-to"
                v-model="dateTo"
                label="(To) Event Date"
                from-date-id="route-events-date-from"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-tabs icons-and-text @change="onTabChanged">
        <v-tabs-slider color="primary" />
        <v-tab ripple href="#events">
          Events {{ selectedTab !== 'events' ? `(${totalEvents})` : '' }}
          <v-icon>fal fa-calendar-alt</v-icon>
        </v-tab>
        <v-tab ripple href="#archived-events" v-if="hasUserType('admin')">
          Archived Events {{ selectedTab !== 'archived-events' ? `(${totalArchivedEvents})` : '' }}
          <v-icon>fal fa-archive</v-icon>
        </v-tab>
        <v-tabs-items v-model="selectedTab">
          <v-tab-item value="events">
            <v-data-table
              v-if="selectedTab === 'events'"
              :headers="headers"
              :items="events"
              :pagination.sync="pagination"
              :total-items="totalEvents"
              :loading="apiInProgress"
              :rows-per-page-items="[10, 25, 50]"
              @update:pagination="onPagination"
              class="elevation-1"
              must-sort
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.eventDateLabel }}</td>
                  <td>{{ props.item.flatRateFeeLabel }}</td>
                  <td>{{ props.item.returnFlatRateFeeLabel }}</td>
                  <td>
                    <div class="d-flex justify-space-between">
                      <span v-if="metricsByEventId[props.item.id] && metricsByEventId[props.item.id].capacityStatus">
                        <div>
                          <strong>Out:</strong>
                          {{ metricsByEventId[props.item.id].capacityStatus.ticketsSold }}
                          /
                          {{ metricsByEventId[props.item.id].capacityStatus.totalCapacity }}
                        </div>
                        <div>
                          <strong>Ret:</strong>
                          <span v-if="props.item.returnFlatRateFee !== null && props.item.returnFlatRateFee !== undefined">
                            <span v-if="metricsByEventId[props.item.id].capacityStatus.returnTicketsSold !== undefined && metricsByEventId[props.item.id].capacityStatus.returnTicketsSold !== null">
                              {{ metricsByEventId[props.item.id].capacityStatus.returnTicketsSold }}
                              /
                              {{ metricsByEventId[props.item.id].capacityStatus.totalReturnCapacity }}
                            </span>
                            <span v-else>— / —</span>
                          </span>
                          <span v-else class="grey--text">N/A</span>
                        </div>
                      </span>
                      <span v-else>— / —</span>
                      <div>
                        <v-btn
                          icon
                          small
                          :loading="metricsByEventId[props.item.id] && metricsByEventId[props.item.id].loading"
                          @click.stop="loadMetricsForEvent(props.item.id)"
                          :title="'Refresh capacity and profiles'"
                        >
                          <v-icon small>fal fa-sync</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </td>
                  <td>
                    <v-tooltip bottom v-if="metricsByEventId[props.item.id]">
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{ metricsByEventId[props.item.id].transportationProfiles !== null ? metricsByEventId[props.item.id].transportationProfiles.length : '—' }}
                        </span>
                      </template>
                      <span v-if="metricsByEventId[props.item.id].transportationProfiles && metricsByEventId[props.item.id].transportationProfiles.length">
                        <div v-for="profile in metricsByEventId[props.item.id].transportationProfiles" :key="profile.id">
                          {{ `(${profile.shortcodeId}) ${profile.licensePlateNumber}` }}
                        </div>
                      </span>
                      <span v-else>No attached vehicles</span> -->
                    </v-tooltip>
                    <span v-else>—</span>
                  </td>
                  <td>{{ props.item.dateUpdatedLabel }}</td>
                  <td class="justify-space-between layout px-0" style="min-width: 80px">
                    <v-btn
                      flat
                      icon
                      title="Edit event"
                      :disabled="!hasUserType('admin') || isOnlyInvestor"
                      @click.stop="loadEvent(props.item.id)">
                      <v-icon small>
                        fas fa-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      title="Archive event"
                      :disabled="!hasUserType('admin') || props.item.isArchiveInProgress || isOnlyInvestor"
                      :loading="props.item.isArchiveInProgress"
                      @click.stop="archiveEventRow(props.item)">
                      <v-icon small>
                        fas fa-archive
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>

          <v-tab-item value="archived-events" v-if="hasUserType('admin')">
            <v-data-table
              v-if="selectedTab === 'archived-events'"
              :headers="archivedHeaders"
              :items="archivedEvents"
              :pagination.sync="pagination"
              :total-items="totalArchivedEvents"
              :loading="apiInProgress"
              :rows-per-page-items="[10, 25, 50]"
              @update:pagination="onPagination"
              class="elevation-1"
              must-sort
            >
              <template v-slot:items="props">
                <tr>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.eventDateLabel }}</td>
                  <td>{{ props.item.flatRateFeeLabel }}</td>
                  <td>{{ props.item.returnFlatRateFeeLabel }}</td>
                  <td>{{ props.item.dateCreatedLabel }}</td>
                  <td>{{ props.item.dateArchivedLabel }}</td>
                  <td class="justify-space-between layout px-0" style="min-width: 80px">
                    <v-btn
                      flat
                      icon
                      title="View event"
                      :disabled="!hasUserType('admin')"
                      @click.stop="loadEvent(props.item.id)">
                      <v-icon small>
                        fas fa-eye
                      </v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      title="Un-archive event"
                      :disabled="!hasUserType('admin') || props.item.isArchiveInProgress"
                      :loading="props.item.isArchiveInProgress"
                      @click.stop="unarchiveEventRow(props.item)">
                      <v-icon small>
                        fas fa-undo
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
    <router-view
      :force-root-view-refresh="forceRootViewRefresh"
      :signed-in-user="signedInUser"
      :has-user-type="hasUserType">
    </router-view>
  </div>
</template>

<script>
import src from './src'
export default src
</script>
